module.exports = __webpack_public_path__ + "static/img/30.52f1faff.webp";